import { createHandler as initGriffin } from 'griffin-paypal/number';
import _get from 'lodash/get';

let griffin;
let currencyMetadata;
const MAX_AMOUNT_LENGTH = 9;
__initializeGriffin();

function __initializeGriffin() {
	try {
		if (!currencyMetadata) {
			__getCurrencyMetadata();
		}
		if (currencyMetadata && !griffin) {
			griffin = initGriffin(currencyMetadata);
		}
	} catch (err) {
		console.log(err);
	}
}

export function getGriffin() {
	return griffin;
}

function __getCurrencyMetadata() {
	const serverProps = document.getElementById('server-props');
	const serverPropsData = (serverProps && serverProps.innerHTML) || '{}';
	try {
		currencyMetadata = _get(JSON.parse(serverPropsData), 'currencyMetadata');
	} catch (err) {
		console.warn(err);
	}
}

function _getAmountValue(currencyParts) {
	var amount = currencyParts && currencyParts.find((item) => item.type === 'value');
	return amount && amount.value;
}

export function formatAmount(value, currency) {
	value = value.replace(/[^0-9]/g, '') || 0;
	value = parseInt(value, 10).toString();

	if (value.length === 1) {
		value = `00${value}`;
	} else if (value.length === 2) {
		value = `0${value}`;
	} else if (value.length > MAX_AMOUNT_LENGTH) {
		value = value.substr(0, MAX_AMOUNT_LENGTH);
	}

	const digits = _get(griffin, `metadata.currencyInfo[${currency}].digits`);
	const negativeDigits = `-${digits}`;

	// Some currencies (eg: JPY) do not have decimal points
	if (digits > 0) {
		value = `${value.slice(0, negativeDigits)}.${value.slice(negativeDigits)}`;
	}

	return formatCurrency({ value, currency });
}

export function formatAmountFromServer (value, currency) {
	const digits = _get(griffin, `metadata.currencyInfo[${currency}].digits`);
	const negativeDigits = `-${digits}`;

	if (value.indexOf('.') < 0) {
		if (digits === 2) {
			value = `${value}.00`;
		}
		if (digits === 1) {
			value = `${value}.0`;
		}
	} else {
		const digitsAfterDecimalPoint = value.split('.')[1].length;
		if (digitsAfterDecimalPoint === 1 && digits === 2) {
			value = `${value}0`;
		}
	}

	value = value.replace(/[^0-9]/g, '') || 0;
	value = parseInt(value, 10).toString();

	if (value.length === 1) {
		value = `00${value}`;
	} else if (value.length === 2) {
		value = `0${value}`;
	} else if (value.length > MAX_AMOUNT_LENGTH) {
		value = value.substr(0, MAX_AMOUNT_LENGTH);
	}

	// Some currencies (eg: JPY) do not have decimal points
	if (digits > 0) {
		value = `${value.slice(0, negativeDigits)}.${value.slice(negativeDigits)}`;
	}

	return formatCurrency({ value, currency });
}

function formatCurrency(params) {
	if (!params.value || !params.currency) {
		return '';
	}

	if (!currencyMetadata) {
		return params.value;
	}

	let response = griffin.formatCurrency({
		value: params.value,
		currency: params.currency
	}, griffin.CURRENCY_FORMAT.parts());

	return _getAmountValue(response);
}

export function normalizeNumber(amount) {
	if (!amount) {
		return ''
	}

	return griffin.normalizeNumber(amount);
}

export function formatCurrencyAsISOFormat(params) {
	return griffin.formatCurrency(params, griffin.CURRENCY_FORMAT_SYMBOLISOCURRENCY);
}



// WEBPACK FOOTER //
// ./buttons/utils/amountUtils.js